// extracted by mini-css-extract-plugin
export var formContainer = "_de-0";
export var message = "_de-1";